import { CardMedia, CardMediaProps } from "@mui/material";
import { useRef, useState } from 'react';
import useProcessImage, { UploadProps, defaultAllowedTypes, defaultMaxSize } from '../../hooks/useProcessImage';
import useFormStyles from "../../styles/formStyles";

interface Props extends CardMediaProps {
  uploadProps?: UploadProps
  allowedTypes?: string[]
  maxSize?: number
}

export default function CardMediaDropZone({
  uploadProps, allowedTypes = defaultAllowedTypes, maxSize = defaultMaxSize, ...rest
}: Props) {
  const formStyles = useFormStyles()
  const [inDropZone, setInDropZone] = useState(false)
  const dropZone = useRef<HTMLDivElement | null>(null)
  const processFile = useProcessImage(allowedTypes, maxSize, uploadProps)

  const preventDefaults = (event: React.DragEvent) => {
    event.preventDefault()
    event.stopPropagation()
  }

  const handleDragEnter = (event: React.DragEvent) => {
    preventDefaults(event)
    setInDropZone(true)
    event.dataTransfer.dropEffect = "copy"
  }

  const handleDragLeave = (event: React.DragEvent) => {
    preventDefaults(event)
    if (event.currentTarget.contains(event.relatedTarget as Node)) return
    setInDropZone(false)
  }

  const handleDrop = (event: React.DragEvent) => {
    preventDefaults(event)
    setInDropZone(false)
    const file = event.dataTransfer.files[0]
    processFile(file)
  }

  return (
    <div
      className={
        !inDropZone ? formStyles.dropZone :
        !uploadProps ? `${formStyles.dropZone} dragover-disabled` :
        `${formStyles.dropZone} dragover`
      }
      onDragEnter={handleDragEnter}
      onDragOver={preventDefaults}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      ref={dropZone}
    >
      <CardMedia {...rest} />
    </div>
  )
}
